import PodcastIcon from "@/assets/icons/microphone.svg";
import NewspaperIcon from "@/assets/icons/newspaper.svg";
import RadioIcon from "@/assets/icons/radio.svg";
import TVIcon from "@/assets/icons/TV.svg";
import { SOURCE, Source } from "@/constants";
import {
  FacebookIcon,
  InstagramIcon,
  LinkedinIcon,
  TiktokIcon,
  XIcon,
  YoutubeIcon,
} from "@/Icons";

export const SOURCE_ICON: Partial<{ [key in Source]: IconComponent }> = {
  [SOURCE.PODCAST]: PodcastIcon,
  [SOURCE.RADIO]: RadioIcon,
  [SOURCE.TV]: TVIcon,
  [SOURCE.WEB_TV]: TVIcon,
  [SOURCE.YOUTUBE]: YoutubeIcon,
  [SOURCE.TWITTER]: XIcon,
  [SOURCE.INSTAGRAM]: InstagramIcon,
  [SOURCE.TIKTOK]: TiktokIcon,
  [SOURCE.FACEBOOK]: FacebookIcon,
  [SOURCE.LINKEDIN]: LinkedinIcon,
  [SOURCE.NEWS]: NewspaperIcon,
};
